import _Vue from "vue";

export function Constants(Vue: typeof _Vue, options?: any): void {
  Vue.prototype.$constants = {
    test: "test"
  }
}
